import { configureStore } from '@reduxjs/toolkit';
import { userSlice } from '../redux/slices/UserSlice';
export default configureStore({
  reducer: {
    user: userSlice.reducer
  }
});